import { render, staticRenderFns } from "./pointrecord.vue?vue&type=template&id=25602264"
import script from "./pointrecord.vue?vue&type=script&lang=js"
export * from "./pointrecord.vue?vue&type=script&lang=js"
import style0 from "./pointrecord.vue?vue&type=style&index=0&id=25602264&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports